// @predictdotfun/sdk 在 predictAccount 模式用 Buffer.from 再 signMessage；瀏覽器無全域 Buffer 會導致「Failed to EIP-712 sign…」且一鍵撤單後無法重掛
import { Buffer } from 'buffer';
if (typeof globalThis.Buffer === 'undefined') globalThis.Buffer = Buffer;

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
